module.exports = __webpack_public_path__ + "static/img/shangjiaruzhu.7f96ee25.png";